var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsersSolid = function SvgUsersSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.667 8.25c0 2.347-1.866 4.25-4.167 4.25-2.301 0-4.167-1.903-4.167-4.25S6.2 4 8.5 4c2.301 0 4.167 1.903 4.167 4.25ZM20.778 11.75c0 1.519-1.244 2.75-2.778 2.75s-2.778-1.231-2.778-2.75S16.466 9 18 9s2.778 1.231 2.778 2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M8.5 4.6c-1.959 0-3.567 1.623-3.567 3.65S6.541 11.9 8.5 11.9s3.567-1.623 3.567-3.65S10.459 4.6 8.5 4.6ZM3.733 8.25c0-2.667 2.123-4.85 4.767-4.85s4.767 2.183 4.767 4.85S11.144 13.1 8.5 13.1s-4.767-2.183-4.767-4.85ZM18 9.6c-1.208 0-2.178.968-2.178 2.15s.97 2.15 2.178 2.15c1.209 0 2.178-.968 2.178-2.15S19.208 9.6 18 9.6Zm-3.378 2.15c0-1.856 1.518-3.35 3.378-3.35s3.378 1.494 3.378 3.35S19.86 15.1 18 15.1s-3.378-1.494-3.378-3.35Zm.215 5.771c-1.543-1.875-3.804-3.071-6.337-3.071-3.82 0-7.01 2.712-8.076 6.383A.6.6 0 0 0 1 21.6h22a.6.6 0 0 0 .575-.772c-.737-2.462-2.94-4.278-5.575-4.278a5.638 5.638 0 0 0-3.163.971Z",
    clipRule: "evenodd"
  })));
};
export default SvgUsersSolid;